
<render-highlightable
[inputString]="obj[prop]"
[entryId]="obj.entryId"
[prop]="prop"
[isWholeHighlight]="true"
(click)="highlighter.checkInitWholeHighlight(obj.entryId, prop, obj[prop])"
 data-ui-name="Render highlightable" data-ui-component="render-math" data-testid="render-math-render-highlightable">
  <span #mathField role="img" [attr.aria-label]="getAccessibleText()" data-ui-name="Get Accessible Text()" data-ui-component="render-math" data-testid="render-math-get-accessible-text"></span>
</render-highlightable>
